angular.module('CarsSaraBo').directive('opaqueRateComponent', function () {
	return {
		restrict: 'E',
		controller: ['$window', '$cookieStore', '$routeParams', 'OpaqueRateService', '$location', 'LoadingWheelService', 'NotificationService', 'SessionService', '$rootScope', 'ModalService', 'OpaqueRateGAConfig', OpaqueRateController],
		controllerAs: 'ctrl',
		templateUrl: 'templates/opaque-rate/opaque-rate.component.html',
		scope: {} // isolated scope
	};
});

function OpaqueRateController($window, $cookieStore, $routeParams, opaqueRateService, $location, loadingWheelService, notificationService, sessionService, $rootScope, modalService, opaqueRateGAConfig) {
	var vm = this;
	var gaOpaqueRate = opaqueRateGAConfig.reviewGa();

	vm.initialize = function () {
		loadingWheelService.show();
		gaOpaqueRate.send("Page_view");

		vm.pagination = {
			itemsPerPage: 10,
			currentPage: 1,
			numPages: 0,
			totalItems: 0
		}
		vm.opaqueRates = [];
		vm.companyOid = $routeParams.companyOid;
		vm.hasCreatePermission = sessionService.loggedUserAllowed('PERM_OPAQUE_RATE_CREATE');
		vm.hasDeletePermission = sessionService.loggedUserAllowed('PERM_OPAQUE_RATE_DELETE');
		vm.modalClosable = true;

        vm.options = {
            expires: new Date("2117")
        };

        vm.modalOpaque = document.querySelector("dsp-modal-coachmark");
        getOpaqueRates();
	}

	function getOpaqueRates() {
		opaqueRateService.fetchByFilter({companyOid: vm.companyOid}, vm.pagination.currentPage, 10).then(function (response) {
			if (response.totalItems > 0) {
				setPaginationValues(response);
				//vm.opaqueRates = [{"companyOid":2,"oid":1,"name":"test2","discountPercentage":16,"validityPeriod":{"from":"2017-06-26","to":"2017-06-30"},"cars":[{"oid":1794,"version":4,"name":"NISSAN ALTIMA OR SIMILAR","carModel":{"oid":151,"version":0,"brand":"CHEVROLET","model":"AGILE","category":"E","categoryCode":"economic","type":"D","countryOid":20010,"picture":{"oid":16,"version":2,"title":"d1e06e27-5773-4fef-9c5d-f7ef7f98d35f","fileName":"d1e06e27-5773-4fef-9c5d-f7ef7f98d35f","url":"https://intranet.despegar.com/media/pictures/d1e06e27-5773-4fef-9c5d-f7ef7f98d35f"}}},{"oid":7381,"version":5,"name":"NISSAN ALTIMA OR SIMILAR","carModel":{"oid":566,"version":0,"brand":"NISSAN","model":"ALTIMA","category":"I","categoryCode":"intermediate","type":"C","countryOid":20208,"picture":{"oid":584,"version":1,"title":"14373a00-2e5c-48b3-a580-17b87ccda443","fileName":"14373a00-2e5c-48b3-a580-17b87ccda443","url":"https://intranet.despegar.com/media/pictures/14373a00-2e5c-48b3-a580-17b87ccda443"}}},{"oid":7380,"version":5,"name":"FORD ESCAPE OR SIMILAR","carModel":{"oid":897,"version":0,"brand":"FORD","model":"ESCAPE","category":"S","categoryCode":"fullsize","type":"F","countryOid":20208,"picture":{"oid":1585,"version":1,"title":"541a7cf7-daa3-483c-a1dc-a2bdecfee339","fileName":"541a7cf7-daa3-483c-a1dc-a2bdecfee339","url":"https://intranet.despegar.com/media/pictures/541a7cf7-daa3-483c-a1dc-a2bdecfee339"}}}],"companyName":"[IC]-Rentadora de test","pointsOfSale":[{"oid":189,"version":35,"name":"sadsa"}],"creationDateTime":"2017-06-22T17:16:00.000Z","allCarsSelected":false,"allPointsOfSaleSelected":false,"type":"DISCOUNT"}];
				vm.opaqueRates = response.items;
			} else {
				vm.opaqueRates = [];
			}
			loadingWheelService.hide();
		});
	};

	function setPaginationValues(page) {
		vm.pagination = {
			itemsPerPage: page.itemsPerPage,
			currentPage: page.currentPage,
			numPages: Math.floor(page.totalItems / page.itemsPerPage) +
			(page.totalItems / page.itemsPerPage > 0 ? 1 : 0),
			totalItems: page.totalItems
		};
	}

	vm.paginationFromNumber = function () {
	    var total = vm.opaqueRates.length;
	    var items;

        if (total > vm.pagination.itemsPerPage){
            items = vm.pagination.itemsPerPage;
        } else if (total <= vm.pagination.itemsPerPage){
            items = total;
        }

		return ( items ) + ((vm.pagination.currentPage - 1) * vm.pagination.itemsPerPage);
	};

	vm.paginationToNumber = function () {
		return vm.paginationFromNumber() + vm.opaqueRates.length - 1;
	};

	vm.changePage = function () {
        getOpaqueRates();
        $window.scrollTo(0, 0);
    };

	vm.showModal = function (param) {
		vm.modalOpaque.show();
		gaOpaqueRate.send("Modal_ayuda", param);
	}

	vm.modalCompleted = function (event) {
        var notificationsReadCookie = $cookieStore.get('modalOpaqueRead');
        if (!notificationsReadCookie || notificationsReadCookie == undefined) {
            $cookieStore.put('modalOpaqueRead', 'true', vm.options);
            vm.modalClosable = true;
        }
	}

	vm.getLanguage = function () {
		return $rootScope.lang.name;
	}
	var helpForm = {
		es: "https://docs.google.com/forms/d/e/1FAIpQLSdCIykFWGGevr29LTWFwTXH7RdwVvUCB3mGg12IReBqemGjBQ/viewform?usp=sf_link",
		pt: "https://docs.google.com/forms/d/e/1FAIpQLSdudhJUeYg0ioi-CDMdjwlCVGUl2DgrS_VX5cis8n6fsbnrag/viewform?usp=sf_link",
		en: "https://docs.google.com/forms/d/e/1FAIpQLSdN33cKGghW-elnYooAnmK_scvJdLcUwhzZSOwTbdMJTJg0JA/viewform?usp=sf_link"
	};

	vm.redirectToHelpForm = function () {
		gaOpaqueRate.send("Boton_consulta");
		window.open(helpForm[$rootScope.lang.value]);
	};

	vm.remove = function (opaqueRate) {
		modalService.show('REMOVE_OPAQUE_RATE_TITLE', 'REMOVE_OPAQUE_RATE_MESSAGE', function () {
			opaqueRateService.remove(vm.companyOid, opaqueRate.oid)
				.then(function (response) {
						gaOpaqueRate.send("Eliminar_tarifa_opaca", opaqueRate.discountPercentage);
						notificationService.displayToast('opaqueRate.toast.removedOfferTitle', 'opaqueRate.toast.removedOfferMessage', {"name": opaqueRate.name});
						vm.initialize();
						$location.path("/company/" + vm.companyOid + "/opaquerate");
					}, function (error) {
						console.log(error);
					}
				);
		});
	};

	vm.addOpaqueRate = function () {
		gaOpaqueRate.send("Agregar_tarifa_opaca");
		$location.path("/company/" + vm.companyOid + "/opaquerate/add")
	};

	vm.notifyGA = function () {
		gaInfo.send(Event)
	};

	function handleError(responseError) {
		if (responseError.data && responseError.data.params) {
			trackError(responseError.data.message, responseError.data.params.name);
			$scope.responseErrorMessage = responseError.data.message;
			$scope.responseErrorParams = responseError.data.params;
		} else {
			$scope.validationErrors = responseError.data;
		}
		document.getElementById('error-message-container').scrollIntoView();
	}

	vm.initialize();


}



//////////////////
// WEBPACK FOOTER
// ./public/app/opaque-rate/opaque-rate.component.js
// module id = 831
// module chunks = 3